import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { cn } from '@/lib/utils'

type SectionCardProps = {
  title: string
  description?: React.ReactNode
  children: React.ReactNode
  actions?: React.ReactNode
}

export function SectionCard({
  title,
  description,
  actions,
  children,
}: SectionCardProps) {
  return (
    <Card
      className={cn(
        // 卡片的“产品感”：柔和边框 + 轻阴影 + 更统一的圆角
        'border-border/70 bg-background rounded-2xl border shadow-sm'
      )}
    >
      <CardHeader className='px-6 pt-6 pb-4'>
        <div className='flex items-start justify-between gap-4'>
          <div className='min-w-0 space-y-1'>
            <CardTitle className='text-[15px] leading-6 font-semibold'>
              {title}
            </CardTitle>

            {description ? (
              <CardDescription className='text-muted-foreground text-xs leading-5'>
                {description}
              </CardDescription>
            ) : null}
          </div>

          {actions ? <div className='shrink-0'>{actions}</div> : null}
        </div>
      </CardHeader>

      <CardContent className='px-6 pt-0 pb-6'>
        <div className='space-y-4'>{children}</div>
      </CardContent>
    </Card>
  )
}
